type CDNOptions = {
  [key: string]: string;
};

// Env is selected at build time via REACT_APP_HOST_TYPE (see the build:*/start:*
// scripts in package.json). This replaces the Gen1 approach of reading the env
// off the aws-exports REST stage suffix, which no longer exists under Gen2
// (amplify_outputs.json carries no stage name).
export type BackendEnv = "local" | "dev" | "master";

const HOST_TYPE_TO_ENV: Record<string, BackendEnv> = {
  local: "local",
  development: "dev",
  staging: "master", // staging builds run against the master backend
  production: "master",
};

export const getBackendEnv = (): BackendEnv =>
  HOST_TYPE_TO_ENV[process.env.REACT_APP_HOST_TYPE || "local"] || "local";

export const CDN: CDNOptions = {
  dev: "https://dh2jw0564x0cd.cloudfront.net",
  master: "https://storage.blings.io",
};

export const getCDN = () => (getBackendEnv() === "master" ? CDN.master : CDN.dev);

export const environment =
  getBackendEnv() === "master" ? "production" : "development";
export const EXTENSION_SOURCE = "EXTENSION_SOURCE";
